import { render } from "./ThematicAnalysis.vue?vue&type=template&id=08d68b2a"
import script from "./ThematicAnalysis.vue?vue&type=script&lang=js"
export * from "./ThematicAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__